import currentGradDate from '../../utilities/current-grad-date'
import getGradYear from '../../utilities/get-grad-year'
import moment from 'moment'

const useSchoolYear = ({
    offset = 0
} = {}) => {
    const endDate = moment(currentGradDate).add(offset, 'y').format('YYYY-MM-DD')
    const startDate = moment(endDate).subtract(12, 'M').add(1, 'd').format('YYYY-MM-DD')
    //  Determines the offset between the targetDate and the current school year
    const getOffset = (targetDate) => getGradYear(targetDate) - getGradYear()
    return {
        startDate,
        endDate,
        getOffset,
    }
}

export default useSchoolYear